import { selectChannelFromTargetCategory } from '@store/selectors/channels'
import { useTypedAction } from '@hooks/common/useTypedActions'
import { useTypedSelector } from '@hooks/common/useTypedSelector'
import { ALL_CHANNELS_CATEGORY_ID } from '@utils/vars'

export const useSetLastWatchedCatchupProgram = (): (() => void) => {
  const isLive = useTypedSelector((state) => state.player.hlsPlayer.isLive)
  const channelData = useTypedSelector((state) =>
    selectChannelFromTargetCategory(state, {
      categoryId: ALL_CHANNELS_CATEGORY_ID,
    })
  )
  const { app_setLastWatchedCatchupProgram } = useTypedAction()

  return () => {
    if (isLive) return
    if (channelData?.type === 'noslate') return
    app_setLastWatchedCatchupProgram()
  }
}
